// Canonical brand neutral constants for JS-side rendering paths.
//
// Until this file existed, three drifting cream values lived in different
// modules (`#F0E8D6` in legibleOn, `#FBF4E2` in Icon.factory, `#f4ede3` as
// `--palette-cream`). In production, marker rendering reads `--color-text-on-dark`
// (which resolves to `--palette-cream`) so the visible color was always
// `#f4ede3` — the JS literals only diverged in tests/SSR. Same story for
// charcoal: `#393C3D` was a JS-only literal that never matched the CSS
// `--palette-neutral-1000` it was meant to mirror.
//
// `tokens/__tests__/contrast.test.ts` regex-checks these against the CSS
// primitive tokens at test time, so any future drift fails CI immediately.
export const CREAM = '#f4ede3';
export const CHARCOAL = '#121210';

// `HOLLOW` is the icon-cutout fill when a category glyph isn't passed a
// `bgColor` by its parent. It exists so the cutout matches the typical
// surface color (`--color-cream`); aliased to `CREAM` so a future palette
// shift updates both at once.
export const HOLLOW = CREAM;
